import {
	SERVICE_DESK_PRODUCT,
	defaultRedirectForSettings,
} from '../ui/product-routes/common/index.tsx';

export const FedRAMPFallbackRedirectToProjectSettings =
	defaultRedirectForSettings(SERVICE_DESK_PRODUCT);
